import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { WorkflowSetupPageWrapper } from "./WorkflowSetupPageWrapper";

type RestrictProcessingInstructionsPageProps = {
  embedded?: boolean;
};

export const RestrictProcessingInstructionsPage = ({
  embedded = false,
}: RestrictProcessingInstructionsPageProps = {}) => {
  const history = useHistory();
  const pageContent = <></>;

  if (embedded) {
    return pageContent;
  }

  return (
    <WorkflowSetupPageWrapper
      selectedTabKey="restrict-processing-request"
      nextOnClick={() => history.push(Routes.organization.requestHandling.requestToOptOut)}
      nextDisabled={false}
      nextContent="Next"
    >
      {pageContent}
    </WorkflowSetupPageWrapper>
  );
};
